import React from "react";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    ReferenceLine,
    Legend,
    LabelList,
} from "recharts";
import { construirPuntosGrafica } from "../helpers/puntosGraficaCierres";
import {
    COLOR_POR_TIPO,
    TIPO_LABORATORIO,
    TIPO_LIQUIDACION,
    TITULOS_POR_TIPO,
} from "../helpers/tiposReporteCierres";
import { TickPeriodoCierre } from "./TickPeriodoCierre";

// Una barra por versión del reporte, con los nombres y colores de la columna
// del acumulado en USD y de la gráfica de variación
const SERIES = [
    {
        dataKey: "diferencia_usd_acumulada_laboratorio",
        nombre: TITULOS_POR_TIPO[TIPO_LABORATORIO].acumuladoUsd,
        color: COLOR_POR_TIPO[TIPO_LABORATORIO],
    },
    {
        dataKey: "diferencia_usd_acumulada_liquidacion",
        nombre: TITULOS_POR_TIPO[TIPO_LIQUIDACION].acumuladoUsd,
        color: COLOR_POR_TIPO[TIPO_LIQUIDACION],
    },
];

const formatearDolares = (decimales) => (valor) =>
    (valor < 0 ? "-$" : "$") +
    Math.abs(valor).toLocaleString("en-US", {
        minimumFractionDigits: decimales,
        maximumFractionDigits: decimales,
    });

const formatearDolaresSinCentavos = formatearDolares(0);
const formatearDolaresConCentavos = formatearDolares(2);

// Espacio para la etiqueta de la barra más alta y de la más baja
const MARGEN_ETIQUETAS_EJE = { top: 20, bottom: 20 };

// Acumulado en USD de laboratorio y de liquidación de cada cierre del rango.
// Un cierre sin acumulado queda sin barra, igual que su celda en la tabla
export const GraficaMonetariaCierres = ({ hook }) => {
    const { graficaMonetaria } = hook;

    if (!graficaMonetaria.length) {
        return null;
    }

    const data = construirPuntosGrafica(graficaMonetaria, SERIES);

    return (
        <div className="reporte-cierres-mensuales__grafica">
            <ResponsiveContainer>
                <BarChart
                    data={data}
                    margin={{
                        top: 20,
                        right: 40,
                        left: 20,
                        bottom: 10,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                        dataKey="periodo"
                        interval={0}
                        height={45}
                        tick={<TickPeriodoCierre />}
                    />

                    <YAxis
                        width={90}
                        padding={MARGEN_ETIQUETAS_EJE}
                        tickFormatter={formatearDolaresSinCentavos}
                    />

                    <ReferenceLine y={0} stroke="#000" strokeWidth={2} />

                    <Tooltip formatter={formatearDolaresConCentavos} />

                    <Legend />

                    {SERIES.map((serie) => (
                        <Bar
                            key={serie.dataKey}
                            dataKey={serie.dataKey}
                            fill={serie.color}
                            name={serie.nombre}
                        >
                            <LabelList
                                position="top"
                                formatter={formatearDolaresSinCentavos}
                                fill={serie.color}
                                fontSize={12}
                            />
                        </Bar>
                    ))}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};
